// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CTopic_abstract } from './../abstract/SagaSchema/CTopic_abstract';
export class CTopic extends CTopic_abstract {}
